export const environment = {
  production: true,
  backend: 'https://bms-slr-api.tor.eviviz.com',
  environment: 'production'
};
